import React from 'react'
import styled from 'styled-components'
import { H2 } from '../Typography'
import { Container } from '../Container'

const Header = styled.header`
  height: 64px;
  background: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center; /* Changed to center to align internal container */
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
`

const HeaderContent = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout?.page?.maxWidth || '1800px'};
  padding: ${({ theme }) => theme.layout?.page?.padding || '0 24px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
`

const Main = styled.main`
  flex: 1;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export function TopBar({ title, logo, actions, children, style, className }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Header style={style} className={className}>
        <HeaderContent>
          <Container direction="horizontal" gap={16} alignItems="center" padding="0">
            {logo && <div style={{ display: 'flex', alignItems: 'center' }}>{logo}</div>}
            {typeof title === 'string' ? <H2 style={{ margin: 0 }}>{title}</H2> : title}
          </Container>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', whiteSpace: 'nowrap' }}>
            {actions}
          </div>
        </HeaderContent>
      </Header>
      <Main>
        {children}
      </Main>
    </div>
  )
}
